import { CreateFromAnotherOrUpdateQuoteInput, QuoteModel } from '@cpak/adp-cpak-quotes-service-models';

export function quoteModelToCreateFromAnotherOrUpdateQuoteInput(data: QuoteModel): CreateFromAnotherOrUpdateQuoteInput {
  return {
    number: data.number,
    status: data.status,
    description: data.description,
    accountId: data.accountId,
    procedureId: data.procedureId,
    languageId: data.languageId,
    engineeringNumber: data.engineeringNumber,
    countryId: data.countryId,
    internalNotes: data.internalNotes,
    ownerId: data.ownerId,
    archived: data.archived,
    instructions: data.instructions,
  };
}
